import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    GetAttributesFilter,
    GetConditionFilter,
    GetValuesByOptionAndField,
    GetValuesByOptionFieldAndUserId,
    GetValuesToFilterLogByField,
} from '../../../reduxToolkit/Search/SearchApi';
import fieldId from '../../../hooks/fieldId';
import conditionId from '../../../hooks/conditionId';
import { MODELS } from '../../../Apis/Models';
import { fieldNameEnum } from '../../../enums/fieldNameEnum';
import { fieldModel } from '../../../enums/fieldModelEnum';
import { format } from 'date-fns';
import {toast} from "react-toastify";
import {DATA_TYPE_MODEL, getFieldNameByValue, SEARCH_OPERATION_MODEL} from "../Model/Model";
import {DATE_TIME_FORMAT_NAME_MODEL} from "../../../Apis/functions";

const SearchForApp = ({
      open,
      onFiltered,
      moduleId,
      option,
      finalArray,
      modelType,
      setSearch,
      cleanAdvance,
      setCleanAdvance,
      cleanRules,
      setFinalArray,
      searchElement,
      userId = null,
      noShowFilters = null,
      callGetValuesApi=null,
      isAttendance
  }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(false);
    const [field, setField] = useState('');
    const [fieldName, setFieldName] = useState('');
    const [sort, setSort] = useState('ASC');
    const [typeAttribute, setTypeAttribute] = useState('');
    const [condition, setCondition] = useState('');
    const [operationKey, setOperationKey] = useState('');
    const [valueAttribute, setValueAttribute] = useState('');
    const [dateAttribute, setDateAttribute] = useState(null);
    const [finalRules, setFinalRules] = useState([]);
    const [inputString, setInputString] = useState(true);
    const [inputNumber, setInputNumber] = useState(false);
    const [inputTwoNumbers, setInputTwoNumbers] = useState(false);
    const [inputDropdown, setInputDropdown] = useState(false);
    const [inputDate, setInputDate] = useState(false);
    const [inputTwoDates, setInputTwoDates] = useState(false);
    const [inputTransferableList, setInputTransferableList] = useState(false);
    const [originalArray, setOriginalArray] = useState([]);
    const [modelName, setModelName] = useState('');
    const [isValidFrom, setIsValidFrom] = useState(true);
    const [fromValue, setFromValue] = useState(null);
    const [toValue, setToValue] = useState(null);
    const [isValidTo, setIsValidTo] = useState(true);
    const [advancedSearch, setAdvancedSearch] = useState(true);
    const [isValidDate, setIsValidDate] = useState(true);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [emptyFields, setEmptyFields] = useState(false);
    const [availablesList, setAvailablesList] = useState([]);
    const [assignedList, setAssignedList] = useState([]);
    const [listRules, setListRules] = useState([]);
    const [attributesFilter, setAttributesFilter] = useState([]);

    let conector = '';
    let valueName = '';
    let idList = [];
    let nameList = [];
    let uuidName = '';

    useEffect(()=>{
        if (userId) setContractorId(userId)
        else setContractorId(sessionStorage.getItem('contractorId'))
    },[userId])

    const handleDateChange = (date) => {
        setDateAttribute(date);
    };

    const handleFromDateChange = (date) => {
        setFromValue(date);
    };
    const handleToDateChange = (date) => {
        if (!date) return;

        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        setToValue(endOfDay);
    };


    useEffect(() => {
        if (cleanAdvance || cleanRules) {
            handleDeleteAllRules();
        }
    }, [cleanAdvance]);

    const {
        getConditionFilter,
        getValuesByOptionAndField,
        getValuesByOptionFieldAndUserId,
        getValuesToFilterLogByField,
    } = useSelector((state) => state.SearchSlice);

    let getValues;

    if (modelType !== undefined && modelType !== '') {
        getValues = getValuesToFilterLogByField;
    } else if (contractorId === null && supplierId === null) {
        getValues = getValuesByOptionAndField;
    } else {
        getValues = getValuesByOptionFieldAndUserId;
    }

    const handleAssign = (element) => {
        setAvailablesList(availablesList.filter((item) => item.id !== element.id && item.name !== element.name));
        setAssignedList([...assignedList, element]);
        setEmptyFields(false);
    };

    const handleDeallocate = (element) => {
        setAssignedList(assignedList.filter((item) => item.id !== element.id && item.name !== element.name));
        setAvailablesList([...availablesList, element]);
    };

    const transferAllToAssigned = () => {
        const updatedAssignedList = [...assignedList, ...availablesList];
        setAssignedList(updatedAssignedList);
        setAvailablesList([]);
        if(updatedAssignedList?.length > 0) setEmptyFields(false);
    };

    const transferAllToAvailables = () => {
        const updatedAvailablesList = [...availablesList, ...assignedList];
        setAvailablesList(updatedAvailablesList);
        setAssignedList([]);
    };

    const handleAddRule = () => {
        if (!advancedSearch) {
            setOriginalArray([]);
            setListRules([]);
        }
        if (field === '' ||
            (!advancedSearch && condition === '') ||
            (condition !== '' && !['NU', 'NN', 'BT', 'NB'].includes(operationKey) && !inputDate && (valueAttribute === null || valueAttribute === undefined || valueAttribute === '')) ||
            (inputDate && (dateAttribute === null || (!isValidDate))) ||
            (condition !== '' && ['BT', 'NB'].includes(operationKey) && (fromValue === null || (!isValidFrom) || toValue === null || (!isValidTo))) ||
            (condition !== '' && ['IN', "NI"].includes(operationKey) && assignedList.length === 0)
        ) {
            setEmptyFields(true);
        } else {
            setEmptyFields(false);
            let newRule = '';
            listRules.length < 1 ? (conector = '') : checked ? (conector = t('or')) : (conector = t('and'));
            if (getFieldNameByValue(fieldName)) {
                if (valueAttribute !== undefined) {
                    valueName = t(fieldNameEnum[fieldName][+valueAttribute]).toUpperCase();
                } else {
                    valueName = '';
                }
            } else {
                valueName = valueAttribute;
            }
            if (condition === '') {
                newRule = conector + ' ' + fieldId(field) + ' ' + t('order') + ' ' + sort;
                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR :  SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    sort: sort,
                    table: modelName,
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else if (['NU', 'NN'].includes(operationKey) === true) {
                newRule = conector + ' ' + fieldId(field) + ' ' + conditionId(condition) + ' ' + t('order') + ' ' + sort;
                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR :  SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else if (inputTransferableList === true) {
                nameList = assignedList.map((item) => item?.name);
                if (typeAttribute === 'UUID' || getFieldNameByValue(fieldName)) {
                    idList = assignedList.map((item) => item?.id);
                }

                newRule =
                    conector +
                    ' ' +
                    fieldId(field) +
                    ' ' +
                    conditionId(condition) +
                    ' ' +
                    nameList.join(', ') +
                    ' ' +
                    t('order') +
                    ' ' +
                    sort;

                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR :  SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                    values: (typeAttribute === 'UUID' || getFieldNameByValue(fieldName))
                            ? idList
                            : nameList,
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else if (inputDate === true) {
                newRule =
                    conector +
                    ' ' +
                    fieldId(field) +
                    ' ' +
                    conditionId(condition) +
                    ' ' +
                    format(dateAttribute, DATE_TIME_FORMAT_NAME_MODEL.shortMonthDayYearTime24WithSeconds) +
                    ' ' +
                    t('order') +
                    ' ' +
                    sort;
                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR :  SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                    values: [dateAttribute.getTime()],
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else if (inputTwoDates === true) {
                newRule =
                    conector +
                    ' ' +
                    fieldId(field) +
                    ' ' +
                    conditionId(condition) +
                    ' ' +
                    t('from') +
                    ' ' +
                    format(fromValue, DATE_TIME_FORMAT_NAME_MODEL.shortMonthDayYearTime24WithSeconds) +
                    ' ' +
                    t('to') +
                    ' ' +
                    format(toValue, DATE_TIME_FORMAT_NAME_MODEL.shortMonthDayYearTime24WithSeconds) +
                    ' ' +
                    t('order') +
                    ' ' +
                    sort;
                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR : SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                    from: fromValue.getTime(),
                    to: toValue.getTime(),
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else if (inputTwoNumbers === true) {
                newRule =
                    conector +
                    ' ' +
                    fieldId(field) +
                    ' ' +
                    conditionId(condition) +
                    ' ' +
                    t('from') +
                    ' ' +
                    fromValue +
                    ' ' +
                    t('to') +
                    ' ' +
                    toValue +
                    ' ' +
                    t('order') +
                    ' ' +
                    sort;
                const newElement = {
                    dataOption: checked ? SEARCH_OPERATION_MODEL.OR : SEARCH_OPERATION_MODEL.AND,
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                    from: parseFloat(fromValue),
                    to: parseFloat(toValue),
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            } else {
                {
                    if (typeAttribute === 'UUID') {
                        const foundItem = getValues.find((obj) => obj.id === valueAttribute);
                        if (foundItem) {
                            uuidName = foundItem.name; // Asignar el nombre si se encuentra un objeto coincidente
                        }
                    }
                }
                typeAttribute === 'UUID' ? (valueName = uuidName) : (valueName = valueName);
                newRule =
                    conector +
                    ' ' +
                    fieldId(field) +
                    ' ' +
                    conditionId(condition) +
                    ' ' +
                    valueName +
                    ' ' +
                    t('order') +
                    ' ' +
                    sort;
                const newElement = {
                    dataOption: checked ? 'or' : 'and',
                    fieldType: typeAttribute,
                    filterKey: fieldName,
                    operation: operationKey,
                    sort: sort,
                    table: modelName,
                    values: [valueAttribute],
                };
                setOriginalArray((prevArray) => [...prevArray, newElement]);
            }
            if (advancedSearch) {
                setListRules([...listRules, newRule]);
                handleClear();
            } else {
                setListRules([newRule]);
            }
        }
    };

    useEffect(() => {
        if (!advancedSearch && listRules.length > 0) {
            handleSearch();
        }
    }, [listRules]);

    const handleDeleteRule = (index) => {
        const updatedListRules = listRules.filter((_, i) => i !== index);
        setListRules(updatedListRules);
        const updateOriginalArray = originalArray.filter((_, i) => i !== index);
        setOriginalArray(updateOriginalArray);
        if (isAttendance && originalArray.length === 1) {
            setSearch(false);
            setCleanAdvance(true);
        }
    };

    const handleDeleteAllRules = () => {
        setListRules([]);
        setOriginalArray([]);
        onFiltered([]);
    };

    const handleSearch = () => {
        setFinalRules(listRules);
        onFiltered(originalArray);
        setSearch(true);
        setCleanAdvance(false);
    };

    useEffect(() => {
        setCondition('');
        if (field !== '') {
            dispatch(GetConditionFilter(typeAttribute));

            if(callGetValuesApi === null){
                //No get values to filter by type attribute equals to DATE
                if(typeAttribute === DATA_TYPE_MODEL.DATE)
                    return;

                if (modelType !== undefined && modelType !== '') {
                    dispatch(GetValuesToFilterLogByField({ model: modelType, field: fieldName }));
                } else if (contractorId === null && supplierId === null) {
                    dispatch(GetValuesByOptionAndField({ option: option, field: fieldName }));
                } else {
                    dispatch(
                        GetValuesByOptionFieldAndUserId({
                            option: option,
                            field: fieldName,
                            userId: contractorId !== null ? contractorId : supplierId,
                        }),
                    );
                }
            }else{
                callGetValuesApi({option, fieldName, userId});
            }

            setModelName(fieldModel[field]);
        } else {
            setInputTransferableList(false);
            setInputDropdown(false);
            setInputNumber(false);
            setInputTwoNumbers(false);
            setInputDate(false);
            setInputTwoDates(false);
            setInputString(true);
        }
    }, [field]);

    useEffect(() => {
        setValueAttribute('');
        setDateAttribute(null);
        setFromValue(null);
        setToValue(null);
        setEmptyFields(false);
        setInputTransferableList(false);
        setInputDropdown(false);
        setInputNumber(false);
        setInputTwoNumbers(false);
        setInputDate(false);
        setInputTwoDates(false);
        setInputString(true);
        if (typeAttribute === 'STRING') {
            if (['EQ', 'NE'].includes(operationKey)) {
                setInputString(false);
                setInputDropdown(true);
            } else if (['IN', 'NI'].includes(operationKey)) {
                setInputString(false);
                setInputTransferableList(true);
                setAvailablesList(Object.values(getValues).map((text) => {
                    return {
                        id: text,
                        name: text
                    }
                }));
                setAssignedList([]);
                setValueAttribute([]);
            } else {
                setInputString(true);
            }
        } else if (typeAttribute === 'LONG') {
            if (['EQ', 'NE'].includes(operationKey)) {
                setInputString(false);
                setInputDropdown(true);
            } else {
                setInputString(false);
                setInputTransferableList(true);
                if (getFieldNameByValue(fieldName)) {
                    setAvailablesList(
                        Object.values(getValues).map((id) => {
                            return {
                                id: parseInt(id),
                                name: t(fieldNameEnum[fieldName][+id]).toUpperCase()
                            }
                        })
                    );
                    setAssignedList([]);
                    setValueAttribute([]);
                } else {
                    setAvailablesList(Object.values(getValues).map((text) => {
                        return {
                            id: text,
                            name: text
                        }
                    }));
                    setAssignedList([]);
                    setValueAttribute([]);
                }
            }
        } else if (typeAttribute === 'INTEGER') {
            if (['IN', 'NI'].includes(operationKey)) {
                setInputString(false);
                setInputTransferableList(true);
                setAvailablesList(Object.values(getValues).map((text) => {
                    return {
                        id: text,
                        name: text
                    }
                }));
                setAssignedList([]);
                setValueAttribute([]);
            } else if (['BT', 'NB'].includes(operationKey)) {
                setInputString(false);
                setInputTwoNumbers(true);
            } else {
                setInputString(true);
                setInputNumber(true);
            }
        } else if (typeAttribute === 'DATE') {
            if (['BT', 'NB'].includes(operationKey)) {
                setInputString(false);
                setInputTwoDates(true);
            } else {
                setInputString(false);
                setInputDate(true);
            }
        } else if (typeAttribute === 'BOOLEAN') {
            setInputString(false);
            setInputDropdown(true);
        } else if (typeAttribute === 'UUID') {
            if (['EQ', 'NE'].includes(operationKey)) {
                setInputString(false);
                setInputDropdown(true);
            } else if (['IN', 'NI'].includes(operationKey)) {
                setInputString(false);
                setInputTransferableList(true);
                setAvailablesList(getValues.map((item) => {
                    return {
                        id: item.id,
                        name: item.name
                    }
                }));
                setAssignedList([]);
                setValueAttribute([]);
            } else {
                setInputString(true);
            }
        }
    }, [condition]);

    //This section indicates what to do when we click clean button
    const handleClear = () => {
        setField('');
        setCondition('');
        setValueAttribute('');
        setDateAttribute(null);
        setFromValue(null);
        setToValue(null);
        setInputNumber(false);
        setInputTwoNumbers(false);
        setInputDropdown(false);
        setInputDate(false);
        setInputTwoDates(false);
        setInputTransferableList(false);
        setInputString(true);
        if (!advancedSearch) {
            handleDeleteAllRules();
        }
    };

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    useEffect(() => {
        if (advancedSearch) {
            handleClear();
        }
        setOriginalArray(finalArray);
        if (finalArray.length === 0) {
            setFinalRules([]);
            setListRules([]);
        } else {
            setListRules(finalRules);
        }
        if (open) {
            dispatch(GetAttributesFilter(moduleId)).then(({payload:{data:{data}}}) => {
                if(noShowFilters === null) setAttributesFilter(data);
                else setAttributesFilter(data.filter(e => !noShowFilters.includes(e.id)));
            });

            if (condition === '') {
                setModelName(Object.keys(MODELS).find((key) => MODELS[key] === +moduleId));
            }
        }
    }, [open]);

    useEffect(() => {
        if(finalArray?.length > 0 && searchElement){
            setFinalArray([]);
            toast.info(t('filters_reset_message')); // Show a toast message
        }
    }, [finalArray, searchElement]);

    // useEffect to show a toast when filter dialog visibility changes
    useEffect(() => {
        if (open && searchElement) {
            toast.info(t('filters_reset_message')); // Show a toast message
        }
    }, [open, searchElement]);


    return {
        t,
        advancedSearch,
        setTypeAttribute,
        fieldName,
        setFieldName,
        field,
        setField,
        sort,
        setSort,
        emptyFields,
        operationKey,
        setOperationKey,
        condition,
        setCondition,
        inputDropdown,
        typeAttribute,
        valueAttribute,
        setValueAttribute,
        fromValue,
        setFromValue,
        toValue,
        setToValue,
        dateAttribute,
        isValidDate,
        setIsValidDate,
        isValidFrom,
        setIsValidFrom,
        isValidTo,
        setIsValidTo,
        checked,
        inputDate,
        inputTwoDates,
        inputTwoNumbers,
        inputString,
        inputNumber,
        inputTransferableList,
        listRules,
        availablesList,
        assignedList,
        attributesFilter,
        getConditionFilter,
        getValues,
        handleDateChange,
        handleFromDateChange,
        handleToDateChange,
        handleAssign,
        handleDeallocate,
        transferAllToAssigned,
        transferAllToAvailables,
        handleAddRule,
        handleDeleteRule,
        handleChange,
        handleSearch,
        handleClear,
        handleDeleteAllRules
    };
};

export default SearchForApp;
